module.exports = __webpack_public_path__ + "img/blue-map-marker.svg?f6be5e96463f131543d606f7a2bbd4ab";